import * as momentOriginal from 'moment';
import 'moment/locale/pt-br';

momentOriginal.locale('pt-br');

export const moment = momentOriginal;
